import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { Cart } from "../../../library-js/php/cart/Cart";
import { RegExpUtility } from "../../../library-js/text/RegExpUtility";
import { RokojoriCart } from "../../js/cart/RokojoriCart";
import { Rokojori } from "../../js/Rokojori";
import { ProductsTable } from "../../js/store/ProductsTable";
import { ConsumerPrice } from "../../../library/ts/vanilla/ecommerce/ConsumerPrice";
import { AssetsCart } from "../../js/assets/AssetsCart";
import { AssetInfo } from "../../js/assets/AssetInfo";
import { RootPathResolver } from "../../../library-js/dom-tools/RootPathResolver";

export class CartPrice
{
  static readonly type = new ElementType( "cart-price" );
  static readonly taxType = new ElementType( "cart-price-tax" );
  static readonly info = new ElementType( "cart-info" );

  static price:[number,number] = [0,0];
  static tax:[number,number]   = [0,0];
  
  static priceLabel:string;
  static taxLabel:string;
  
  static infoLabel:string;

  static taxRate:number = 0.19;

  static cart:AssetsCart;

  
  static async applyOnDocument()
  {
    CartPrice.updateCart();

    CartPrice.applyAll();
    
  }

  static async applyAll()
  {
    await CartPrice.computePrice();
    CartPrice.type.forAllInDoc( e => CartPrice.applyOnPriceElement( e ) );
    CartPrice.taxType.forAllInDoc( e => CartPrice.applyOnTaxElement( e ) );
    CartPrice.info.forAllInDoc( e => CartPrice.applyOnInfoElement( e ) );
  }

  static updateCart()
  {
    if ( CartPrice.cart == Rokojori.$.assetManagerServer.assetsCart )
    {
      return;
    }

    CartPrice.cart = Rokojori.$.assetManagerServer.assetsCart;

    CartPrice.cart.onChanged.addListener(
      async ()=>
      {
        CartPrice.applyAll();
      }
    )
  }

  static async computePrice()
  {
    let products = await Rokojori.$.assetManagerServer.getItems( false );

    let prices = products.map( p => p.purchaseOption.price );
    let sum = ConsumerPrice.sum( prices );

    CartPrice.price = sum.gross;
    CartPrice.priceLabel = `${sum.gross[ 0 ]},${RegExpUtility.prependZeros( sum.gross[ 1 ] + "", 2)} €`;

    CartPrice.tax = sum.tax;
    CartPrice.taxLabel = `${sum.tax[ 0 ]},${ RegExpUtility.prependZeros( sum.tax[ 1 ] + "", 2)} €`;

    let infoLabel = products.map( 
      p => CartPrice.createImage( p ) + " "+ Rokojori.locale( p.title ) ).join( "<br> " );

    infoLabel = products.length + " asset(s): <br>" + infoLabel;
    

    CartPrice.infoLabel = infoLabel;
    

  }

  static createImage( assetInfo:AssetInfo )
  {
    let imagePath = "::/_graphics/assets/asset-no-image.jpg";

    if ( assetInfo.previewImagePath )
    {
      imagePath = Rokojori.locale( assetInfo.previewImagePath );
    }

    if ( RootPathResolver.isRootPath( imagePath ) )
    {
      imagePath = Rokojori.$.pathConverter.rootToRelative( imagePath );
    }

    let image = `<img class="cart-price-preview-image" src="${imagePath}">`
    return image;
  }

  static async applyOnPriceElement( e:Element)
  {
    e.innerHTML = CartPrice.priceLabel;
  }

  static async applyOnTaxElement( e:Element)
  {
    e.innerHTML = CartPrice.taxLabel;
  }

  static async applyOnInfoElement( e:Element)
  {

    e.innerHTML = CartPrice.infoLabel;
  }

}